// ************************************ WINDOW LOAD: ************************************
function footer(){ 
    /*el alto que tiene el navegador*/
    var alto_navegador= $(window).height();
    /*el alto que tiene el contenido de la pagina*/
    var alto_documento= $(document).height(); 
    /*  aqui condicionamos si el alto del contenido 
    *  es mayor que
    *  el alto del navegador*/
    if(alto_documento > alto_navegador){
        /* si es mayor es que tiene un contenido mas 
        * largo que el alto del navegador y entonces lo dejamos a relativo*/
        $("footer").css({"position":"relative"})
    }else{
        /* si el alto del contenido es menor que el alto del navegador es que
        * tenemos espacio vacio y le mandamos abajo*/
        $('.page').css({"height": "100vh"});
        $("footer").css({"bottom": 0, "position":"fixed"})
    } 
}

$(window).on('load', function(){
	/**
	 * 1. Abrir buscador menu.
     * 2. Abrir modal login.
     * 3. Poblaciones por provincia.
     * 4. Tabs.
     * 5. Colocar footer en la parte inferior de la pantalla.
	 */

	// 1. Abrir buscador menu.
    $('.btnOpenSearch').on('click', function(){
        if($('.nav-search').hasClass('opened')){
        	$('.nav-search').stop().animate({width: 0});
            $('.nav-search').removeClass('opened');
            $('.nav-search .nav-search-icon').addClass('d-lg-none');  
            $('.nav-search .nav-search-input').addClass('d-lg-none');  
            $('.nav-search input').css('padding', '0');
            
        }else{
        	$('.nav-search').stop().animate({width: "635px"});
            $('.nav-search').addClass('opened');  
            $('.nav-search .nav-search-icon').removeClass('d-lg-none');  
            $('.nav-search .nav-search-input').removeClass('d-lg-none');  
            $('.nav-search input').trigger( "focus" );
        }
    });

    // 1b. Toggle menú lateral (pantallas ≤1300px).
    $('#btnToggleRightMenu').on('click', function(e) {
        e.preventDefault();
        var $menu = $('#right-menu');
        var $icon = $(this).find('i');

        $menu.toggleClass('opened');
        $icon.toggleClass('fa-bars fa-times');
    });

    $(document).on('click', function(e) {
        var $menu = $('#right-menu');
        if (
            $menu.hasClass('opened') &&
            !$(e.target).closest('#right-menu, #btnToggleRightMenu').length
        ) {
            $menu.removeClass('opened');
            $('#btnToggleRightMenu i').removeClass('fa-times').addClass('fa-bars');
        }
    });

    // 2. Abrir modal login.
    // $('#btnLogin').on('click', function(e){
    //     e.preventDefault();
    //     if($('#login').hasClass('opened')){
    //         $('#login').removeClass('opened');
    //         $('#veil').fadeOut();
    //     }else{
    //         $('#login').addClass('opened');   
    //         $('#veil').fadeIn(); 
    //     }
    // });

    $('#veil, .closeLogin').on('click', function(){
        $('#login').removeClass('opened');
        $('#veil').fadeOut();
    });

    // 3. Poblaciones por provincia.
    $('#province_id').on('change', function(event){
        //Limpiamos posibles valores de población:
        $('#town_id').empty().val('');
        $('#province_id option:selected').each(function(){
            var id = event.target.value;
            
            if(id == null || id == 0){
                $('#town_id').attr('disabled','disabled');
            }else{
                $('#town_id').removeAttr('disabled');
                $.get("/province-towns/"+id+"", function(response, state){
                    $("#town_id").append('<option value="">'+txtPoblacionSelec+'</option>');
                    for(i=0; i<response.length; i++){
                        $("#town_id").append('<option value="'+response[i].id+'">'+response[i].name+'</option>');    
                    }
                });
            }
        });
    });

    // 4. Tabs.
    $('.letter').on('click', function(e){
        e.preventDefault();
        var letter = $(this).data('letter');
        $('.letter').removeClass('active');
        $(this).addClass('active');
        $('.tab').removeClass('active');
        $('#tab_'+letter).addClass('active');
    });

    // 5. Colocar footer en la parte inferior de la pantalla.
    footer();

});